import React from "react";
import { ConfigProvider, DatePicker as AntDatePicker } from "antd";
import type { DatePickerProps as AntDatePickerProps } from "antd";
import type { Dayjs } from "dayjs";
import { CalendarOutlineIcon } from "assets/icons";
import "./DatePicker.css";

export type DatePickerProps = AntDatePickerProps<Dayjs>;

export const DatePicker: React.FC<DatePickerProps> = ({
  className = "",
  prefix = <CalendarOutlineIcon width={16} height={16} />,
  suffixIcon = null,
  getPopupContainer = () => document.body,
  popupClassName = "",
  popupStyle,
  ...props
}) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#FF6929",
          colorInfo: "#FF6929",
          colorPrimaryHover: "#0ea371",
          colorPrimaryActive: "#0b8a60",
          borderRadius: 8,
        },
        components: {
          DatePicker: {
            cellHoverBg: "#FF6929",
          },
        },
      }}
    >
      <AntDatePicker
        {...props}
        prefix={prefix}
        suffixIcon={suffixIcon}
        className={`h-[34px] py-2 bg-inherit border-none hover:bg-inherit ${className}`}
        getPopupContainer={getPopupContainer}
        popupClassName={`app-date-picker-popup ${popupClassName}`.trim()}
        popupStyle={{ zIndex: 9999, ...popupStyle }}
      />
    </ConfigProvider>
  );
};
